import { useEffect } from 'react'
import { toastStore } from 'shared/ui'
import { WebsocketEvent } from 'entities/WebSocket/store'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type IResponseEventAccessRequestApproved } from 'entities/Users/api/types'

type IHandlerEvent = (data: IResponseEventAccessRequestApproved) => void

export const useEventAccessRequestApproved = (handler?: IHandlerEvent) => {
  const { websocket } = useEntitiesContext()

  const defaultHandler = (data: IResponseEventAccessRequestApproved) => {
    toastStore.add({
      type: 'success',
      title: 'Your request was approved',
    })

    handler?.(data)
  }

  useEffect(() => websocket.on(WebsocketEvent.AccessRequestApproved, defaultHandler), [])
}
